export default "__VITE_ASSET__9dbdfa3e__"